import bannersObject from '../indexes/banners.json'
import faviconsObject from '../indexes/favicons.json'
import iconsObject from '../indexes/icons.json'
import logosObject from '../indexes/logos.json'
import splashScreensObject from '../indexes/splashScreens.json'
import { article } from './article'
import { FooterConfig } from './footer'
import { slotLayouts } from './layouts'
import { sideMenuLeft } from './menus'
import { teasers } from './teasers'
import { templates } from './templates'
import { topbar } from './topbar'

const { content: banners } = bannersObject
const { content: favicons } = faviconsObject
const { content: logos } = logosObject
const { content: icons } = iconsObject
const { content: splashScreens } = splashScreensObject

export const TocantinsAssets = {
  article,
  banners,
  favicons,
  footer: FooterConfig,
  logos,
  icons,
  menus: { sideMenuLeft },
  slotLayouts,
  splashScreens,
  teasers,
  templates,
  topbar
}